import { RandomFromArray } from "slotworks/utils/math/random";
import slotDefinition from "slotworks/model/slot-definition";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import isMcSymbol from "utils/is-mc-symbol";

class ReelsetModifier {

    private initialReelsets: Map<string, string[][]>;

    public init() {
        this.initialReelsets = new Map(slotDefinition.reelsets as any);
    }

    public increaseFrequencyOfSymbol(reelsetName: string, symbolId: string, quantity: number) {
        const reelset = slotDefinition.reelsets.get(reelsetName);
        const quantityPerReel = quantity / reelset.length;

        reelset.forEach((reel) => {
            for (let i = 0; i < quantityPerReel; i++) {
                const randomIndex = Math.floor(reel.length * Math.random());
                reel[randomIndex] = symbolId;
            }
        });
    }

    public restartInitialReelset(reelsetName: string) {
        slotDefinition.reelsets.set(reelsetName, this.initialReelsets.get(reelsetName));
    }

    public updateMCSymbolValues(reelsetName: string) {
        const possibleValues = bonusSymbolSetup.getAnticipationSymbols();
        const reelset = slotDefinition.reelsets.get(reelsetName);

        reelset.forEach((reel) => {
            reel.forEach((symbol, index) => {
                if (isMcSymbol(symbol)) {
                    const randomValue = RandomFromArray(possibleValues);
                    reel[index] = `TT_${randomValue}`;
                }
            });
        });
    }
}

export default new ReelsetModifier();
